import React, { Component } from 'react';
import './SearchBar.css';

export default class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.value);
  }

  onSubmit(e) {
    e.preventDefault();
  }

  render() {
    return (
      <div style={searchStyle} className="searchDiv">
        <form name="search" onChange={this.onChange} onSubmit={this.onSubmit}>
          <input
            type="text"
            className="searchBar"
            placeholder="Name, Zutat.."
          />
          <input type="submit" className="btn" value="Suchen" />
        </form>
      </div>
    );
  }
}

const searchStyle = {
  display: 'flex',
  maxWidth: '100%',
  paddingLeft: '6em',
  paddingBottom: '3em',
  flexAlign: 'center',
  justifyContent: 'flex-start'
};
